import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import InputMask from "react-input-mask";
import { useLocation, useNavigate } from "react-router-dom";
import packageJson from '../../../../../../package.json';
import { useAuth } from "../../../../../providers/AuthContext.tsx";
import { AccountStrings } from "../../../business/core";

export const FormPhoneComponent = ({ setStep, step }) => {
  const { phone, setPhone } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const version = packageJson.version;

  useEffect(() => {
    if (state?.reload) {
      navigate('.', { replace: true, state: {} });
      window.location.reload();
    }
  }, [state, navigate]);

  const [phoneError, setPhoneError] = useState(false);

  const strings = AccountStrings["PTBR"].login;

  const handlePhoneSubmit = (event) => {
    event.preventDefault();
    const numericPhone = phone.replace(/\D/g, "");

    if (numericPhone.length !== 11) {
      setPhoneError(true);
      return;
    }

    if (/^(\d)\1+$/.test(numericPhone)) {
      setPhoneError(true);
      return;
    }

    if (numericPhone[2] !== "9") {
      setPhoneError(true);
      return;
    }

    setPhoneError(false);
    setStep(2);
  };

  // const handleFormSubmit = (event) => {
  //   if (event.key === "Enter") {
  //     event.preventDefault();
  //   }
  // };

  return (
    <>
      <p className="mb-4 text-center">{strings.subtitle[step]}</p>
      <Form
        noValidate
        className="mt-4"
        onSubmit={handlePhoneSubmit}
      // onKeyDown={handleFormSubmit}
      >
        <Form.Group className="mb-3" controlId="formBasicPhone">
          <InputMask
            mask={strings.inputMask}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          >
            {(inputProps) => (
              <Form.Control
                {...inputProps}
                type="tel"
                required
                minLength={20}
                className={`custom-input ${phoneError ? "input-error" : ""}`}
                placeholder={strings.phonePlaceholder}
                isInvalid={phoneError}
                autoComplete="off"
              />
            )}
          </InputMask>
          <Form.Control.Feedback type="invalid">
            {phoneError ? strings.error.invalidNumber : strings.error.default}
          </Form.Control.Feedback>
        </Form.Group>
        <div className="row">
          <div className="col">
            <p className="mt-2">
              <a href="#" className="linkBold" onClick={() => navigate("/signup")}>
                {strings.buttonSignUp}
              </a>
            </p>
          </div>
          <div className="col d-flex flex-row-reverse">
            <Button
              variant="primary"
              type="submit"
              className="px-4 button-flat"
            >
              {strings.buttonNext}
            </Button>
          </div>
        </div>
        <Row>
          <Col className="text-center mt-2"><small style={{ color: '#999999' }}>v{version}</small></Col>
        </Row>
      </Form>
    </>
  );
};
